module.exports = __webpack_public_path__ + "static/kossuth-symbol-DND3_FnP-28a648cbcd9b47d9aded57e4d056ec81.webp";